module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"clear":"Clear","pick":"Pick"}}')
  delete Component.options._Ctor
}
